"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElementInterfaceTypes = exports.CONFIG_DIRECTIVES = exports.DIRECTIVES = void 0;
exports.isFragment = isFragment;
exports.isTemplateLiteral = isTemplateLiteral;
exports.toTemplateLiteral = toTemplateLiteral;
exports.cssvars = cssvars;
exports.DIRECTIVES = ['update', 'create', 'before', 'attribute', 'scope', 'content', 'property', 'cssvar', 'cssclass', 'cssstyle', 'after', 'initial', 'terminal', 'error'];
exports.CONFIG_DIRECTIVES = ['evaluable', 'interruptible', 'cacheable', 'spaceable'];
function isFragment(tag, attributes, type) {
  var _a, _b;
  const directives = ['reference', 'type', 'subtree', 'css'].concat(exports.DIRECTIVES);
  for (const _ref of Object.entries(attributes)) {
    var _ref2 = _slicedToArray(_ref, 2);
    const name = _ref2[0];
    const value = _ref2[1];
    if (!name.startsWith('data-xd-')) continue;
    if (['fragment', ...exports.CONFIG_DIRECTIVES].includes(name.substring(8))) continue;
    if (value.length == 0 || !directives.find(directive => directive == name.substring(8))) throw new Error(`Invalid directive (${name}="${value}")`);
  }
  const names = Object.keys(attributes);
  const conflict = names.some(name => !name.startsWith('data-xd-') || ['attribute', 'property', 'class', 'style', 'reference', 'css'].includes(name.substring(8)));
  const fragment = ('data-xd-fragment' in attributes);
  if (fragment && conflict) throw new Error('data-xd-fragment conflits with other attribute');
  const tags = (_b = (_a = exports.ElementInterfaceTypes[type]) === null || _a === void 0 ? void 0 : _a.FragmentElementTags) !== null && _b !== void 0 ? _b : [];
  return fragment || !conflict && names.length > 0 && tags.includes(tag.toLowerCase());
}
function isTemplateLiteral(data) {
  return /(?<!\\)\${/.test(data);
}
function toTemplateLiteral(data, spaceable) {
  const template = data.replace(/`/g, '\\`');
  const literal = spaceable ? template : template.replace(/^[\t\n\r ]+/, ' ').replace(/[\t\n\r ]+$/, ' ');
  return 'String.raw`' + literal + '`';
}
function cssvars(css) {
  function tag(strings) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }
    return {
      css: strings.raw[0] + values.map((value, index) => `var(--${value})${strings.raw[index + 1]}`).join(''),
      vars: Array.from(new Set(values))
    };
  }
  return Function('tag', 'return tag`' + css + '`')(tag);
}
exports.ElementInterfaceTypes = {
  HTML: {
    ElementInterface: HTMLElement,
    ElementTagNameMap: 'HTMLElementTagNameMap',
    FragmentElementTags: ['div', 'span']
  },
  SVG: {
    ElementInterface: SVGElement,
    ElementTagNameMap: 'SVGElementTagNameMap',
    FragmentElementTags: ['g']
  },
  MathML: {
    ElementInterface: MathMLElement,
    ElementTagNameMap: 'MathMLElementTagNameMap',
    FragmentElementTags: []
  }
};